import { graphql } from "relay-runtime"

const deTimeToTreatQuery = graphql`
  query deTimeToTreatQuery {
    timesToTreatByPointOfCare: de_timesToTreatByPointOfCare {
      pointOfCare
      timesToTreat
    }
  }
`

export { deTimeToTreatQuery as de_TimeToTreatQuery }
